import React, { lazy } from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
export function HeroSection() {
  return <section className="relative pt-12 pb-16 px-6 md:pt-32 md:pb-32 overflow-hidden" data-id="element-72">
      <div className="max-w-4xl mx-auto text-center" data-id="element-73">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8
      }} data-id="element-74">
          <h1 className="text-4xl md:text-6xl lg:text-7xl font-bold leading-tight mb-4 md:mb-6" data-id="element-75">
            Cómo Lograr una Piel de{' '}
            <span className="italic text-gold" data-id="element-76">"Filtro de Instagram"</span> en
            28 Días Sin Gastar $200 en Cremas de Lujo
          </h1>

          <p className="text-lg md:text-2xl text-charcoal/80 mb-6 md:mb-8 max-w-3xl mx-auto font-serif italic" data-id="element-77">
            — Incluso si tienes la piel sensible, manchas rebeldes o crees que
            "lo has probado todo".
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.2
      }} className="bg-white/50 backdrop-blur-sm border border-gold/20 p-6 md:p-8 rounded-2xl mb-8 md:mb-12 shadow-xl" data-id="element-78">
          <p className="text-base md:text-lg leading-relaxed text-charcoal/90" data-id="element-79">
            Deja de financiar el marketing de las marcas de lujo. Aprende a usar{' '}
            <strong className="text-gold font-bold" data-id="element-80">
              "Moléculas de Farmacia"
            </strong>{' '}
            de $12 para transformar tu rostro mientras duermes.
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.4
      }} className="flex flex-col items-center gap-6 md:gap-12" data-id="element-81">
          <div className="w-full max-w-3xl mx-auto rounded-2xl overflow-hidden shadow-2xl border border-gold/20" data-id="element-82">
            <div style={{
            position: 'relative',
            paddingTop: '56.25%'
          }} data-id="element-83">
              <iframe src="https://embed.fliki.ai/embed/69d984da0326ad944db2e4c5" loading="eager" style={{
              border: 0,
              position: 'absolute',
              top: 0,
              height: '100%',
              width: '100%'
            }} allow="accelerometer; gyroscope; autoplay; encrypted-media; picture-in-picture;" allowFullScreen data-id="element-84" />
            </div>
          </div>

          <CTAButton data-id="element-85">Sí, Quiero Mi Piel de Porcelana</CTAButton>

          <div className="max-w-2xl text-left space-y-4 md:space-y-6 text-charcoal/80 text-lg leading-relaxed border-l-2 border-sage pl-6" data-id="element-86">
            <p data-id="element-87">
              ¿Alguna vez has sentido que tu baño parece una sucursal de
              Sephora, pero tu piel sigue viéndose opaca, cansada y con textura?
              No es tu culpa.
            </p>
            <p data-id="element-88">
              Has sido víctima de una industria de $500 billones que prefiere
              gastar en modelos famosas que en los ingredientes activos que
              realmente transforman tu dermis.
            </p>
            <p className="font-medium text-charcoal" data-id="element-89">
              ¿Y si te dijera que el secreto de las pieles de porcelana no está
              en una caja de cristal francesa, sino en el estante de la farmacia
              de tu esquina?
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}